import React from "react";

export default function FormField({ children }) {
  return <div className="md:flex md:items-center mb-6">{children}</div>;
}
